export default {"src":"/_next/static/media/logo-internit.dca4ecce.svg","height":16,"width":45,"blurWidth":0,"blurHeight":0};